module.exports = __webpack_public_path__ + "img/greetings.4525c5fb.svg";